import { TypeInitProps } from '../../types';
import { initAcrawler } from '../../utils/acrawler';
import * as subModuleTypes from '../../types/sso';
import * as subModuleService from './normal';
import BaseInterface from '../base/index';

export default class SsoInterface extends BaseInterface {
  private host: string | undefined;
  private originHost: string;
  public bindMobile: subModuleTypes.TypeBindMobileService;
  public changeMobile: subModuleTypes.TypeChangeMobileService;
  public login: subModuleTypes.TypeLoginService;
  public password: subModuleTypes.TypePasswordService;
  public qrcodeLogin: subModuleTypes.TypeQrcodeLoginService;
  public quickAuth: subModuleTypes.TypeQuickAuthService;
  public register: subModuleTypes.TypeRegister;

  constructor(props: TypeInitProps) {
    super(props, 'sso');
    let { host, printLog, acrawler = '' } = props;
    // log
    if (printLog) {
      console.log(
        '%cSSOInterface Initial Props >>>>%O',
        'background: #222; color: #bada55',
        props
      );
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }
    // SSO address
    this.host = host || '';
    // domain address
    this.originHost = window.location.origin;
    const argus = { ...props, request: this.request };
    this.bindMobile = new subModuleService.BindMobileService(argus);
    this.changeMobile = new subModuleService.ChangeMobileService(argus);
    this.login = new subModuleService.LoginService({
      ...argus,
      originHost: this.originHost,
    });
    this.password = new subModuleService.PasswordService(argus);
    this.qrcodeLogin = new subModuleService.QrcodeLoginService(argus);
    this.quickAuth = new subModuleService.QuickAuthService(argus);
    this.register = new subModuleService.RegisterService(argus);
  }
}
